<template>
  <div class="beiAnContainer">
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      :title="
        todoType == 'add'
          ? '新增部门'
          : todoType == 'edit'
            ? '编辑部门'
            : '查看详情'
      "
      :visible.sync="dialogVisible"
      width="756px"
      custom-class="addoredit"
      @close="close"
    >
      <el-form
        ref="jbxxForm"
        :disabled="todoType == 'look'"
        :rules="rules"
        :model="jbxxForm"
        label-width="90px"
      >
        <el-form-item label="部门编号:" prop="deptCode">
          <el-input v-model="jbxxForm.deptCode" />
        </el-form-item>
        <el-form-item label="信用代码:" prop="tyshxydm">
          <el-input
            v-model="jbxxForm.tyshxydm"
            maxlength="18"
            show-word-limit
            placeholder="统一社会信用代码（18位）"
          />
        </el-form-item>
        <el-form-item v-if="todoType != 'add'" label="变更时间:">
          <el-input v-model="jbxxForm.tyshxydmGxsj" disabled />
        </el-form-item>
        <el-form-item label="上级部门:" prop="parentId">
          <el-cascader
            ref="deptCascader"
            v-model="jbxxForm.parentId"
            :props="{ emitPath: false, checkStrictly: true }"
            :show-all-levels="false"
            style="width: 100%"
            :options="deptTree"
          />
        </el-form-item>
        <el-form-item label="部门名称:" prop="deptName">
          <el-input v-model="jbxxForm.deptName" />
        </el-form-item>
        <el-form-item label="行政区划:" prop="xzqhId">
          <el-cascader
            ref="deptCascader"
            v-model="jbxxForm.xzqhId"
            :show-all-levels="false"
            style="width: 100%"
            :props="props"
            :options="xzqhTree"
          />
        </el-form-item>
        <el-form-item label="机关简称:">
          <el-input v-model="jbxxForm.gajz" />
        </el-form-item>
        <el-form-item label="排序字段:">
          <el-input v-model="jbxxForm.orderNum" />
        </el-form-item>
        <el-form-item label="部门标识:">
          <el-select
            v-model="jbxxForm.deptFlag"
            placeholder="请选择部门标识"
            style="width: 100%"
          >
            <el-option
              v-for="(item, index) in flagList"
              :key="index"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="部门状态:" prop="status">
          <el-select
            v-model="jbxxForm.status"
            placeholder="请选择部门状态"
            style="width: 100%"
          >
            <el-option
              v-for="(item, index) in statusList"
              :key="index"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="签章:" style="width: 100%">
          <el-upload
            :action="returnSaveFile"
            list-type="picture-card"
            :limit="1"
            :on-preview="handlePictureCardPreview"
            :before-upload="beforeUpload"
            :headers="token"
            :class="{ disabled: showUpload }"
            :on-success="onSuccess"
            :on-remove="handleRemove"
            :file-list="fileList"
            :on-progress="handleProgess"
          >
            <i class="el-icon-plus" />
          </el-upload>
          <el-dialog append-to-body :visible.sync="ImgVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          v-if="todoType != 'look'"
          @click="close"
        >取 消</el-button>
        <el-button
          v-preventReClick
          type="primary"
          @click="sureSubmit"
        >确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getDeptTree } from '@/assets/js/yhgl.js'
import { xzqhTree, addDept, editDept } from '@/assets/js/bmgl.js'
import { getToken, returnSaveFile } from '@/assets/js/common.js'
export default {
  data() {
    return {
      flagList: [
        // 部门标识列表
        {
          label: '大队',
          value: 0
        },
        {
          label: '行政审批科',
          value: 1
        }
      ],
      statusList: [
        // 状态列表
        {
          label: '正常',
          value: '0'
        },
        {
          label: '停用',
          value: '1'
        }
      ],
      props: {
        emitPath: false,
        checkStrictly: true
        /*  lazy: true,
        leaf: "leaf", */
        /*  lazyLoad(node, resolve) {
          if (node.level == 0) {
            xzqhTree().then((e) => {
              var nodes = [e.data.data],
                nodes = nodes.map((item) => ({
                  label: item.label,
                  leaf: !item.leaf,
                  value: item.value,
                  childrens: item.children,
                }));
              resolve(nodes);
            });
          }
          if (node.level > 0) {
            if (node.data.isReq) {
              getXzqTreeS(node.data.value).then((res) => {
                var nodes = res.data.data.map((item) => ({
                  label: item.label,
                  leaf: !item.leaf,
                  value: item.value,
                  isReq: item.isReq,
                }));
                resolve(nodes);
              });
            } else {
              var nodes = node.data.childrens.map((item) => ({
                label: item.label,
                leaf: !item.leaf,
                value: item.value,
                isReq: item.isReq,
              }));
              return resolve(nodes);
            }
            return resolve([]); // 加上这个，防止在该节点没有子节点时一直转圈的问题发生。
          }
        }, */
      },
      rules: {
        deptCode: [
          { required: true, message: '请输入部门编号', trigger: 'change' }
        ],
        parentId: [
          { required: true, message: '请选择上级部门', trigger: 'change' }
        ],
        deptName: [
          { required: true, message: '请输入部门名称', trigger: 'change' }
        ],
        xzqhId: [
          { required: true, message: '请选择行政区划', trigger: 'change' }
        ],
        status: [
          { required: true, message: '请选择部门状态', trigger: 'change' }
        ],
        tyshxydm: [
          {
            validator: (rule, value, callback) => {
              if (!value || /^[0-9A-Za-z]{18}$/.test(value)) {
                callback()
              } else {
                callback(new Error('统一社会信用代码必须为18位字母或数字'))
              }
            },
            trigger: 'blur'
          }
        ]
      },
      deptTree: [], // 部门树
      returnSaveFile: '', // 上传文件
      token: {
        Authorization: getToken()
      },
      ImgVisible: false, // 大图弹窗
      dialogImageUrl: '', // 大图
      xzqhTree: [],
      jbxxForm: {},
      dialogVisible: false,
      showUpload: false, // 控制上传按钮的样式
      todoType: '', // 操作类型
      fileList: []
    }
  },
  watch: {
    fileList(newValue, oldValue) {
      if (newValue.length == 0) {
        this.showUpload = false
      } else {
        this.showUpload = true
      }
    }
  },
  mounted() {
    this.returnSaveFile = returnSaveFile()
    // 获取区划树
    getDeptTree().then((e) => {
      this.deptTree = e.data.data
    })
    xzqhTree().then((e) => {
      this.xzqhTree = [e.data.data]
    })
    setInterval(function() {
      document.querySelectorAll('.el-cascader-node__label').forEach((el) => {
        el.onclick = function() {
          if (this.previousElementSibling) this.previousElementSibling.click()
        }
      })
    }, 1000)
  },
  methods: {
    sureSubmit() {
      if (this.todoType == 'add') {
        this.$refs['jbxxForm'].validate((valid) => {
          if (valid) {
            addDept(this.jbxxForm).then((e) => {
              if (e.data.code == '000000') {
                this.$message.success('部门新增成功!')
                this.close()

                this.$parent.loadDataSource()
              }
            })
          }
        })
      } else if (this.todoType == 'edit') {
        this.$refs['jbxxForm'].validate((valid) => {
          if (valid) {
            editDept(this.jbxxForm).then((e) => {
              if (e.data.code == '000000') {
                this.$message.success('部门编辑成功!')
                this.close()

                this.$parent.loadDataSource()
              }
            })
          }
        })
      } else if (this.todoType == 'look') {
        this.close()
      }
    },
    // 上传之前
    beforeUpload(file) {
      const fileType = ['image/jpeg', 'image/png', 'image/bmp', 'image/jpg']
      const isJPG = fileType.includes(file.type)

      const isLt = file.size / 1024 < 500
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/BMP/JPEG/PNG格式!')
      }
      if (!isLt) {
        this.$message.error('上传图片大小不能超过 500kb!')
      }
      return isJPG && isLt
    },
    handleRemove(file, fileList) {
      this.dialogImageUrl = ''
      this.$delete(this.jbxxForm, 'sign')
      if (fileList.length == 0) {
        this.showUpload = false
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.ImgVisible = true
    },
    onSuccess(response, file, fileList) {
      this.dialogImageUrl = response.data.url
      this.jbxxForm.sign = response.data.url
      if (fileList.length == 1) {
        this.showUpload = true
      }
    },
    handleProgess(event, file, fileList) {
      this.fileList = fileList
    },
    close() {
      this.dialogVisible = false
      this.showUpload = false
      this.jbxxForm = {}
      this.$refs['jbxxForm'].resetFields()
      this.fileList = []
    }
  }
}
</script>

<style lang="less" scoped>
.beiAnContainer {
  /deep/ .addoredit {
    .el-dialog__body {
      padding: 20px 40px;
      .el-form {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .el-form-item {
          width: 47%;
          .el-form-item__content {
            display: flex;
          }
        }
      }
    }
  }
  /deep/ .fpuesr {
    .el-dialog__body {
      padding: 20px 40px;
      .el-form {
        display: flex;

        .el-form-item {
          width: 30%;
          margin-right: 20px;
          .el-form-item__content {
            display: flex;
          }
        }
      }
    }
  }
  .el-button--primary {
    color: #fff;
    background: #4170ff;
    border-radius: 3px;
    border-color: #4170ff;
  }
}
/deep/ .disabled .el-upload--picture-card {
  display: none;
}
</style>
